// Tenantra Inc. - Canadian province -> IANA timezone, used to show every date-and-time
// in the account's registered province instead of the viewer's device timezone.
const PROVINCE_TZ = {
  AB: 'America/Edmonton', BC: 'America/Vancouver', MB: 'America/Winnipeg',
  NB: 'America/Moncton', NL: 'America/St_Johns', NS: 'America/Halifax',
  NT: 'America/Yellowknife', NU: 'America/Iqaluit', ON: 'America/Toronto',
  PE: 'America/Halifax', QC: 'America/Toronto', SK: 'America/Regina', YT: 'America/Whitehorse',
};
const DEFAULT_TZ = 'America/Toronto'; // Eastern, until the account has a province

let activeTz = DEFAULT_TZ;

export const provinceToTz = (province) => PROVINCE_TZ[(province || '').toUpperCase()] || DEFAULT_TZ;
export const setActiveTimezone = (province) => { activeTz = provinceToTz(province); };
export const getActiveTimezone = () => activeTz;
